// Slow editorial marquee — massive outlined serif words.
export default function Marquee({ words = ["Trust", "Integrity", "Performance"] }) {
  const items = [...words, ...words, ...words, ...words];
  return (
    <div className="overflow-hidden py-16 border-y border-navy/10 bg-cream" data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {items.map((w, i) => (
          <span
            key={i}
            className="mx-8 font-serif text-6xl md:text-8xl font-semibold"
            style={{
              WebkitTextStroke: "1.5px #112C50",
              color: i % 3 === 1 ? "#F1771E" : "transparent",
            }}
          >
            {w} <span className="text-orange">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
